import { Injectable, Input } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Site, Supervision, SupervisionError } from 'solar-bo';
import { SupervisionFilter } from './supervis-filter.model';


export interface ISdsAction{
  action:string;
  value:any;
}

/**
 * Class to use to share data between components in supervision
 * Esta clase es la que se debe usar para compartir datos entre los componentes del arbol de componentes de la supervision
 * Se ha creado tarde asi que habrá que hacer una migracion de propiedades.
 */
@Injectable()
export class SupervMainService {

    supervision: Supervision;
    site: Site;
    issues: SupervisionError[] = [];//all issues
    issuesFiltered: SupervisionError[] = [];
    svFilter: SupervisionFilter = new SupervisionFilter();// {} as SupervisionFilter;
    /**
     Los componentes que usen la lista de issues deberian subscribirse a los cambios.
     Ahora se esta usando con @Input que tambien es valido, pero a medida que la supervision ha ido creciendo(y crecerá) necesitamos el servicio
     Ejemplo: this.supervMainService.issuesSource.subscribe((issuesSource: any) => {
            console.log('issuesSource: ', issuesSource); imprimira la lista de issues
        });
     */
    issuesSource: BehaviorSubject<SupervisionError[]> = new BehaviorSubject([]);


  constructor() { }


}